export const PersonalNav = [
  {
    name: "收藏",
    type: "One",
  },
  {
    name: "歌单",
    type: "Two",
  },
];

export const enum PersonalNavName {
  Collection = "收藏",
  MySongList = "歌单",
}
